// Noodle & Snoot: Dynamic Shipping Notice logic.
// Isolated into this static asset file 1 August 2026 as part of the
// Dawn-update isolation refactor (see Protected Custom Code Registry,
// item 4). Previously embedded directly in
// sections/main-cart-footer.liquid, which is exactly the kind of file
// a Dawn theme-engine update can silently overwrite (confirmed missing
// entirely from the 31 July 2026 Dawn 15.5.0 update draft). Only the
// two small placeholder <div> lines and a single <script src>
// reference now live in the section file; those are trivial to
// restore even if a merge drops them, unlike this file's full logic.
// Behaviour is unchanged from the original, including the hard-coded
// shipping thresholds noted below.
function renderCartShippingNotice() {
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) throw new Error('Cart data fetch failed');
      return response.json();
    })
    .then(cart => {
      const totalPriceLocal = cart.total_price / 100; // Total in customer's local currency
      const totalWeight = cart.total_weight;
      const currency = cart.currency;

      const line1 = document.getElementById('shipping-notice-line-1');
      const line2 = document.getElementById('shipping-notice-line-2');
      if (!line1 || !line2) return;

      if (cart.item_count === 0) {
        line1.innerText = "";
        line2.innerText = "";
        return;
      }

      // 1. Domestic Flow (Australia Market Session)
      if (currency === 'AUD') {
        if (totalPriceLocal >= 100) {
          line1.innerHTML = "You've unlocked <span style='color: #6B2A2A;'>Free Express Shipping (AU)</span>!";
          line2.innerText = "Your premium sighthound gear qualifies for express delivery.";
        } else {
          const gap = (100 - totalPriceLocal).toFixed(2);
          let costString = "$21.00";

          if (totalWeight <= 250) {
            costString = "$15.00";
          } else if (totalWeight > 250 && totalWeight <= 500) {
            costString = "$17.00";
          } else {
            costString = "$21.00";
          }

          line1.innerHTML = `Current Shipping: <span style='color: #6B2A2A;'>${costString}</span> Express postage`;
          line2.innerHTML = `Spend <span style='color: #6B2A2A;'>$${gap}</span> more to qualify for Free Express Shipping (AU)`;
        }
      }
      // 2. International Flow (Handles KHR, USD, GBP, EUR dynamically)
      else {
        const conversionRate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
          ? parseFloat(window.Shopify.currency.rate)
          : 1;

        const localThreshold = 200 * conversionRate;
        const localShippingFee = (35 * conversionRate).toFixed(2);

        if (totalPriceLocal >= localThreshold) {
          line1.innerHTML = "You've unlocked <span style='color: #6B2A2A;'></span>Free International Shipping!";
          line2.innerText = "Your order qualifies for free worldwide delivery.";
        } else {
          const gap = (localThreshold - totalPriceLocal).toFixed(2);

          const formattedFee = parseFloat(localShippingFee).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
          const formattedGap = parseFloat(gap).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});

          line1.innerHTML = `Current Shipping: <span style='color: #6B2A2A;'>${currency} ${formattedFee}</span> Standard International Postage`;
          line2.innerHTML = `Spend <span style='color: #6B2A2A;'>${currency} ${formattedGap}</span> more to qualify for Free International shipping`;
        }
      }
    })
    .catch(err => {
      console.error('Shipping notice calculation error:', err);
    });
}

document.addEventListener('DOMContentLoaded', renderCartShippingNotice);

const nativeFetch = window.fetch;
window.fetch = function(...args) {
  return nativeFetch.apply(this, args).then(response => {
    if (args[0] && (args[0].includes('/cart/change') || args[0].includes('/cart/add') || args[0].includes('/cart/update') || args[0].includes('/cart/clear'))) {
      setTimeout(renderCartShippingNotice, 100);
    }
    return response;
  });
};
